// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footer_copy":"Footer_footer_copy__3N-Wz","footer_text":"Footer_footer_text__2VZKM"};